export const ENDPOINT = 'api/app/orders';

export type OrderStatusHistoryItem = {
  id: number;
  previous_status: string | null;
  new_status: string;
  status_label: string;
  notes: string;
  created_at: string;
  created_at_human: string;
};

export type OrderStatusHistoryData = {
  order_id: number;
  display_id: string;
  current_status: string;
  history: OrderStatusHistoryItem[];
};

export type Response = {
  success: boolean;
  data: OrderStatusHistoryData;
};
